// Proforma claims keyed by id.
import {
  GET_ADMINISTRATION_PROFORMA_CLAIMS,
  GET_ADMINISTRATION_PROFORMA_CLAIM,
  CREATE_ADMINISTRATION_PROFORMA_CLAIM,
  UPDATE_ADMINISTRATION_PROFORMA_CLAIM,
  DESTROY_ADMINISTRATION_PROFORMA_CLAIM,
  LINK_ADMINISTRATION_PROFORMA_CLAIM_INVOICE,
  CREATE_ADMINISTRATION_PROFORMA_CLAIM_INVOICE,
} from "./actions";

export function AdministrationProformaClaimsReducer(state = {}, action) {
  switch (action.type) {
    case `${GET_ADMINISTRATION_PROFORMA_CLAIMS}_FULFILLED`: {
      return _.mapKeys(action.payload.data, "id");
    }
    case `${GET_ADMINISTRATION_PROFORMA_CLAIM}_FULFILLED`:
    case `${CREATE_ADMINISTRATION_PROFORMA_CLAIM}_FULFILLED`:
    case `${UPDATE_ADMINISTRATION_PROFORMA_CLAIM}_FULFILLED`:
    case `${LINK_ADMINISTRATION_PROFORMA_CLAIM_INVOICE}_FULFILLED`:
    case `${CREATE_ADMINISTRATION_PROFORMA_CLAIM_INVOICE}_FULFILLED`: {
      let newState = _.clone(state);
      const newItem = action.payload.data;
      const id = _.get(newItem, "id");
      newState[id] = newItem;
      return newState;
    }
    case `${DESTROY_ADMINISTRATION_PROFORMA_CLAIM}_FULFILLED`: {
      const id = _.get(action.payload.data, "id");
      return _.omit(state, id);
    }
    default:
      return state;
  }
}
